export default __webpack_public_path__ + "static/media/vc.33cdcde1.jpg";